<div class="motives-container" *ngIf="nodePath?.motives?.length">
    <span class="request-motives-selection-title">
        {{'pt.edp.edponline.requests-and-operations.create-request.select-motive.title' | translate }}
    </span>
    <div class="motives-list">
        <div *ngIf="position !== 0" class="motives-list-header">
            <span (click)="backSelection()">
                <i class="icon-edponline-Bop-078 rotate-180 icon-2x" aria-hidden="true"></i></span>
            <span class="motives-selected-title">{{nodePath.breadcrumb[position]}}</span>
        </div>
        <div class="motives-list-content">
            <div [ngClass]="{'selected-motive': motive.id &&
                motive.id === selectedID}" *ngFor="let motive of loadedMotives"
                (click)="isChildrenAndLast(motive.childs) ? forwardSelection(motive) : selectMotive(motive)">
                <div class="motive">
                    <div><span>{{motive.name}}</span></div>
                    <div *ngIf="isChildrenAndLast(motive.childs)" class="motive-arrow-icon">
                        <i class="mt-n1 font-weight-bold icon-edponline-Bop-073 rotate-270" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
